module.exports = __webpack_public_path__ + "img/yi4.6c86cfaf.jpg";